import Immutable from 'immutable';

export default Immutable.fromJS({
  updatedProductId: null,
  showAll: false,
  type: '',
  filter: null
});
